<rx-alert
  *ngIf="(authFacade.error$ | async)"
  type="danger"
  message="There was a problem impersonating this user, please open a support request
    or contact the priority channel"
></rx-alert>

<div
  class="d-flex justify-content-center"
  *ngIf="(authFacade.isLoading$ | async)"
>
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
